import { render, staticRenderFns } from "./BetslipErrorButton.vue?vue&type=template&id=53a2af3e"
import script from "./BetslipErrorButton.vue?vue&type=script&lang=js"
export * from "./BetslipErrorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports